const firstContentTab = document.querySelectorAll(".main .shopify-section");

if (firstContentTab.length) firstContentTab[1].classList.add("show");

initiateConceptTabLink();

function initiateConceptTabLink() {
  document.addEventListener("click", e => {
    const tabLink = e.target.closest(".tab-link");

    if (tabLink) {
    	const tabContentPosition = tabLink.dataset.position;
      
      e.preventDefault();
      setActiveButton(tabLink);
      showTabContent(tabContentPosition);
    }

  });
}

function setActiveButton(button) {
	const activeTabLink = document.querySelector(".main .tab-link.active");

	if (activeTabLink) activeTabLink.classList.remove("active");
	button.classList.add("active");	
}

function showTabContent(tabNumber) {
	const tabContents = document.querySelectorAll(".main .shopify-section");
	const currentTabContent = document.querySelector(".main .shopify-section.show");

	if (currentTabContent) currentTabContent.classList.remove("show");
	tabContents[tabNumber].classList.add("show");
}